export const ORDER_DASHBOARD_LABELS = {
  upcomingBookingsTitle: "Upcoming booking calendar",
  upcomingBookingsSubtitle: "Booked products and services from visible active orders.",
  upcomingBookingsEmpty: "No upcoming bookings in the current order view.",
  upcomingBookingsLoading: "Loading booking slots...",
  dateOnlyBooking: "Anytime",
  bookedQuantityPrefix: "Qty",
  bookingDateLabel: "Booking date",
  bookingSlotLabel: "Booking slot",
  viewOrder: "View order",
  itemFallback: "Item",
  gridSearchPlaceholder: "Search orders by order id, store, or status",
  gridFilterStatusLabel: "Status:",
  gridFilterBusinessLabel: "Business:",
  gridFilterAll: "All",
};
